<b-container fluid="sm">
    <b-row align-h="center" class="pt-3">
        <b-col cols="12" md="6">
            <b-card type="secondary" shadow header-classes="bg-white">
                <b-card-text>
                    <b-form enctype="multipart/form-data">
                        <!---->
                        <legend>Scode to be sent to</legend>
                        <hr />
                        <b-row>
                            <b-col>
                                <b-form-group label="Mobile Number:" label-for="input-1">
                                    <vue-phone-number-input id="Umbai" v-model="phoneNumber" @update="mobileNumber"
                                        :default-country-code="countryCode" no-example required size="lg" />
                                    <div><span class="text-warning"></span></div>
                                </b-form-group>
                            </b-col>

                        </b-row>
                        <br />
                        <!---->
                        <div>
                            <input type="button" class="btn btn-lg btn-primary btn-block" value="Send Scode"
                                @click="makePayment" />
                        </div>
                    </b-form>
                </b-card-text>
            </b-card>
        </b-col>
    </b-row>
    <div class="vld-parent">
        <loading :active.sync="isLoading" 
        :can-cancel="false" 
        :is-full-page="true"></loading>
    </div>
</b-container>